import { inject, Injectable } from '@angular/core';
import { IInitDataModel } from '../apis/user/model/user.model';
import { Subject } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AppStateService {
  initDataChange = new Subject<IInitDataModel>();
  private readonly router = inject(Router);
  private appData!: IInitDataModel;
  private currentUrl = '/main';
  private previousUrl: string | undefined;

  constructor() {
    this.listenToRouter();
  }

  getAppData(): IInitDataModel {
    return this.appData;
  }

  setAppData(value: IInitDataModel): void {
    this.appData = value;
    this.initDataChange.next(value);
  }

  goToPrevPage(): Promise<boolean> {
    return this.router.navigate([this.previousUrl!]);
  }

  private listenToRouter(): void {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event) => {
        this.previousUrl = this.currentUrl;
        this.currentUrl = (event as NavigationEnd).url;
      });
  }
}
